<app-idle-timeout-wrapper></app-idle-timeout-wrapper>
@if (useAgreement) {
  <app-terms-and-conditions [userAgreement]="user?.useAgreement"></app-terms-and-conditions>
}
@else {
  <div class="l-app">
    <a role="region" class="skip-link" id="skipToMainLink" [routerLink]="[]" (click)="skipToMainContent($event)"
      aria-label="Skip to main content">Skip to main content</a>
    <app-header></app-header>
    <div class="l-main">
      <app-navigation></app-navigation>
      <div class="l-content">
        <main id="main">
          <!-- breadcrumb -->
          <div class="breadcrumb-container">
            <app-breadcrumb></app-breadcrumb>
          </div>
          <router-outlet></router-outlet>
        </main>
        <app-footer></app-footer>
      </div>
    </div>
  </div>
}
<app-refresh-token-wrapper></app-refresh-token-wrapper>
<router-outlet name="chat-modal"/>